import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Button, Snackbar, Alert } from "@mui/material";

import { UTILS } from "@/utils";
import { BASE_URL, ENTITIES_CSV_URL } from "@/constants";
import { userSelector } from "models/selectors/user";
import { DATE_UTILS } from "utils/dates";

import { useGetJobs } from "../hooks";
import { LoadingOrContent } from "@/components";
import { JobsTable } from "../components/JobsTable";

const FILE_NAME = `jobs-${DATE_UTILS.getCurrentDate()}.csv`;

const Jobs = () => {
  const [csv, setCsv] = useState();
  const [copied, setCopied] = useState(false);

  const { user } = useSelector(userSelector);

  const { data: jobs, isLoading: isLoadingJobs, doRequest: getJobs } = useGetJobs();

  const { total = "--" } = jobs?.data || {};

  useEffect(() => {
    (async () => await getJobs())();
  }, []);

  useEffect(() => {
    if (!jobs?.data?.data) return;

    const CSV_FILE_CONTENT = UTILS.handleExport(jobs.data.data);

    setCsv(CSV_FILE_CONTENT);
  }, [jobs]);

  const authHash = user?.auth_hash || "";
  const url = `${BASE_URL}${ENTITIES_CSV_URL.JOBS}?auth_hash=${authHash}`;

  const handleCopy = async (textToCopy) => {
    await navigator.clipboard.writeText(textToCopy);
    setCopied(true);
  };

  return (
    <>
      <h2>Jobs</h2>

      <LoadingOrContent isLoading={isLoadingJobs}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Card
            sx={{ width: 275, display: "flex", alignContent: "center", justifyContent: "center" }}
          >
            <CardContent>
              <Typography variant="h3" component="div">
                {total} Jobs.
              </Typography>
            </CardContent>
          </Card>

          <div style={{ width: "100%", textAlign: "right" }}>
            <Button variant="outlined" onClick={() => handleCopy(url)}>
              Generate CSV URL
            </Button>

            {csv && (
              <Button
                variant="contained"
                component="a"
                href={csv}
                download={FILE_NAME}
                style={{ margin: "14px" }}
              >
                Download CSV
              </Button>
            )}
          </div>
        </div>

        <Snackbar
          open={copied}
          autoHideDuration={2000}
          onClose={() => setCopied(false)}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <Alert onClose={() => setCopied(false)} severity="success" sx={{ width: "100%" }}>
            ¡URL copied to clipboard!
          </Alert>
        </Snackbar>

        <JobsTable jobs={jobs?.data} />
      </LoadingOrContent>
    </>
  );
};

export { Jobs };
